import React from 'react';
import AccountDetails from './accountDetail';
import Grid from '@material-ui/core/Grid';
import RouteHeader from '../RouteHeader/routeHeader';
import {withStyles} from '@material-ui/core/styles';
import ContentGrid from '../../../Helper/gridWrapper/gridWrapper';
import {bindActionCreators} from 'redux';
import load from 'load-script';
import {connect} from 'react-redux';
import './myAccount.css';
import {getProfile} from '../../../Actions/myAccountAction';

const styles = {};

class MyAccount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
          updateState:false,
          callAccountDetail:false
        }
    }
    onUpdate=()=>{
        this.setState({updateState:true})
    }
    componentDidMount(){
      load('https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyBr9MSaEjodT_Q9bnUqUcusJ8HWmQmJRC0', () => {
        this.setState({
          callAccountDetail: true
        })
      });
    }

    render() {
        const { user } = this.props;
        return (
            <div className='container-div'>
                <ContentGrid
                header={
                    user.results.BusinessUser.IsFirstVisit && JSON.parse(user.results.BusinessUser.IsFirstVisit)['Account']?
                        <RouteHeader title={'Account'}
                                 text={'Update your cover and profile picture, see your plan details, view billing history and update your payment method.'}
                        />:<span/>
                }
                content={
                    <Grid container spacing={24}>
                        <Grid item sm={12} xs={12}>
                            <section>
                              {this.state.callAccountDetail && <AccountDetails onUpdate={this.onUpdate} user={this.props.user}/>}
                            </section>
                        </Grid>
                    </Grid>
                }
            />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.myAccount,
        user:state.loginResponse
    }
};

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
    }, dispatch)
};

export default withStyles(styles)(connect(mapStateToProps, matchDispatchToProps)(MyAccount));